import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { UseCasesContext } from "../../../../context/useCases"
import { FiledType, Form } from "../../../components/form"
import { Menu } from "../../../components/menu"

export const CarExcelAdd = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string>("")
    const [success, setSuccess] = useState<string>("")

    let useCases = useContext(UseCasesContext)
    const [form, setForm] = useState<{
        file: File | null,
    }>({
        file: null,
    })

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (form.file !== null) {
            let response = await useCases?.amofileUseCase.CreateAmofileCarXlsx(form.file!)
            if (response instanceof Error) {
                setError(response.message)
                setSuccess("")
            } else {
                console.log(response)
                setError("")
                setSuccess("Файлы упешно отправлены")
            }
        }
    }

    const getIdFromUrl: (url: string) => number = (url: string) => {
        const parsedUrl = new URL(url)
        let items = parsedUrl.pathname.split('/')
        let id = parseInt(items[items.length -1 ])
        return id
    }

    const updateForm = (name: string, value: any) => {
        setForm({
            ...form,
            [name]: value,
        })
    }

    const formatDate = (day: Date) => {
        const yyyy = day.getFullYear();
        let mm = (day.getMonth() + 1).toString(); // Months start at 0!
        let dd = day.getDate().toString();

        if (dd.length == 1) dd = '0' + dd;
        if (mm.length == 1) mm = '0' + mm;

        return dd + '.' + mm + '.' + yyyy;
    }

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-12">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Файл /</span> Добавить файл</h4>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">Загрузка файла по авто amocrm</h5>
                            </div>
                            <div className="card-body">
                                {error!== ""?<div className="alert alert-danger" role="alert">Ошибка добавления: {error}</div>:<></>}
                                {success!== ""?<div className="alert alert-success" role="alert">{success}</div>:<></>}
                                <Form
                                    state={{
                                        loading: false,
                                        error: "",
                                    }}

                                    submit={submit}

                                    fields={[
                                        {
                                            name: "file",
                                            title: "Файл",
                                            placeholder: "Прикрепите файл",
                                            value: form.file,
                                            type: FiledType.FileSingle,
                                        },
                                    ]}
                                    btnSmall={true}
                                    submitBtnTitle={"Загрузить"}
                                    updateForm={updateForm}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
